var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1608 8.55678L8.78894 6.02512V15.9749L12.1608 13.4432L15.4221 11L12.1608 8.55678ZM12.1608 8.55678L8.78894 6.02512V15.9749L12.1608 13.4432L15.4221 11L12.1608 8.55678ZM12.1608 8.55678L8.78894 6.02512V15.9749L12.1608 13.4432L15.4221 11L12.1608 8.55678ZM9.89447 2.23317V0C7.67236 0.221106 5.64925 1.10553 4.01306 2.44322L5.58291 4.02412C6.81005 3.07337 8.2804 2.43216 9.89447 2.23317ZM4.02412 5.58291L2.44322 4.01306C1.10553 5.64925 0.221106 7.67236 0 9.89447H2.23317C2.43216 8.2804 3.07337 6.81005 4.02412 5.58291ZM2.23317 12.1055H0C0.221106 14.3276 1.10553 16.3508 2.44322 17.9869L4.02412 16.406C3.07337 15.1899 2.43216 13.7196 2.23317 12.1055ZM4.01306 19.5568C5.64925 20.8945 7.68342 21.7789 9.89447 22V19.7668C8.2804 19.5678 6.81005 18.9266 5.58291 17.9759L4.01306 19.5568ZM22.0553 11C22.0553 16.7045 17.7216 21.4141 12.1608 22V19.7668C16.4945 19.192 19.8442 15.4774 19.8442 11C19.8442 6.52261 16.4945 2.80804 12.1608 2.23317V0C17.7216 0.58593 22.0553 5.29548 22.0553 11Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.0d5e734119a23bc696c469c4db3b0d5d.svg";
export { ForwardRef as ReactComponent };